export function getCookie(name: string) {
  const matches = document.cookie.match(
    /* eslint-disable-next-line */
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function clearCookie(name: string) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mavenmachines.com`;
}

export const COOKIES = {
  AUTH_SERVICE_TOKEN: 'mvn_token',
};
